module.exports = function surround(str, wrapper) {
  return [wrapper, str, wrapper].join('');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/surround.js
// module id = 289
// module chunks = 0